import axios from "axios";

const portalApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

portalApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("portal_access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default portalApi;
